<script setup lang="ts">
/**
 * SeoFaqItem — one question of an SEO page's FAQ as a paper sheet that folds open
 * (native <details>, so the answer is in the static HTML and works without JS).
 * The "+" sits on a small cream disc and turns to "×" when open.
 */
defineProps<{ question: string; answer: string }>();
</script>

<template>
  <details class="faq paper-sheet group">
    <summary class="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5">
      <h3 class="type-app-heading text-left text-foreground">{{ question }}</h3>
      <span
        class="faq-disc flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-lg leading-none"
        aria-hidden="true"
      >+</span>
    </summary>
    <div class="type-body px-5 pb-5 text-muted-foreground md:px-6">
      {{ answer }}
    </div>
  </details>
</template>

<style scoped>
.faq summary::-webkit-details-marker {
  display: none;
}
.faq summary {
  border-radius: var(--paper-radius);
}
.faq summary:focus-visible {
  outline: 2px solid var(--paper-stock);
  outline-offset: 2px;
}
.faq-disc {
  background: var(--paper-stock);
  color: var(--paper-stock-ink);
  box-shadow: inset 0 1px 0 rgb(255 255 255 / 0.5), 0 2px 4px -1px var(--paper-shade);
  transition: rotate 0.25s cubic-bezier(0.22, 1, 0.36, 1);
}
.faq[open] .faq-disc {
  rotate: 45deg;
}
@media (prefers-reduced-motion: reduce) {
  .faq-disc {
    transition: none;
  }
}
</style>
